export default __webpack_public_path__ + "static/media/rainFive.4e942c9b.jpg";